module.exports = __webpack_public_path__ + "img/caselist19.97728c3f.jpg";